document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.pdp-content');
  const about = document.querySelector('.pdp-about');
  const prose = document.querySelector('.prose-layout');
  const blocks = prose ? Array.from(prose.querySelectorAll('.text-block')) : [];
  const progressTrack = document.querySelector('.pdp-scroll-progress__track');
  const progressFill = document.querySelector('.pdp-scroll-progress__fill');

  if (!section || !about || !prose || !blocks.length) {
    return;
  }

  const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

  let distance = 0;
  let trackStart = 0;
  let started = false;

  function getScrollY() {
    return window.lenis?.scroll ?? window.scrollY;
  }

  function getHeaderHeight() {
    return document.querySelector('.site-header')?.offsetHeight ?? 62;
  }

  function markProseComplete(block) {
    const tl = block._bodyLineTimeline;
    if (!tl) return;
    tl.eventCallback('onComplete', () => {
      block.dataset.proseDone = 'true';
    });
  }

  function measure() {
    if (!isDesktop()) {
      section.style.height = '';
      prose.style.removeProperty('--prose-lead');
      prose.style.removeProperty('--prose-shift');
      distance = 0;
      return;
    }

    const visibleHeight = about.clientHeight;

    // Park the first paragraph against the bottom of the card.
    const firstHeight = blocks[0].offsetHeight;
    prose.style.setProperty('--prose-lead', `${Math.max(0, visibleHeight - firstHeight)}px`);

    distance = Math.max(0, prose.offsetHeight - visibleHeight);

    const headerHeight = getHeaderHeight();
    section.style.height = `${window.innerHeight - headerHeight + distance}px`;
    trackStart = section.getBoundingClientRect().top + getScrollY() - headerHeight;
  }

  function revealVisibleBlocks() {
    const bounds = isDesktop()
      ? about.getBoundingClientRect()
      : { top: 0, bottom: window.innerHeight };
    const trigger = bounds.top + (bounds.bottom - bounds.top) * 0.92;

    blocks.forEach((block, index) => {
      if (block.dataset.revealed === 'true') return;
      if (!block._bodyLineTimeline) return;

      const rect = block.getBoundingClientRect();
      const visible = index === 0
        ? rect.bottom > bounds.top && rect.top < bounds.bottom
        : rect.top < trigger && rect.bottom > bounds.top;

      if (visible) {
        block.dataset.revealed = 'true';
        window.playBodyText?.(block);
        markProseComplete(block);
      }
    });
  }

  function update() {
    if (!isDesktop()) {
      revealVisibleBlocks();
      return;
    }

    const progress =
      distance > 0
        ? Math.min(1, Math.max(0, (getScrollY() - trackStart) / distance))
        : 1;

    prose.style.setProperty('--prose-shift', `${progress * distance}px`);

    if (progressFill && progressTrack) {
      const percent = Math.round(progress * 100);
      progressFill.style.width = `${percent}%`;
      progressTrack.setAttribute('aria-valuenow', String(percent));
    }

    revealVisibleBlocks();
  }

  function refresh() {
    measure();
    update();
  }

  let refreshFrame = 0;
  let settleTimer = 0;

  function scheduleRefresh() {
    if (!refreshFrame) {
      refreshFrame = requestAnimationFrame(() => {
        refreshFrame = 0;
        refresh();
      });
    }

    clearTimeout(settleTimer);
    settleTimer = setTimeout(() => {
      refresh();
      window.lenis?.resize();
      window.ScrollTrigger?.refresh();
    }, 150);
  }

  function start() {
    if (started) return;
    started = true;

    if (window.lenis) {
      window.lenis.on('scroll', update);
    } else {
      window.addEventListener('scroll', update, { passive: true });
    }

    window.addEventListener('resize', scheduleRefresh);
    window.addEventListener('orientationchange', scheduleRefresh);
    window.addEventListener('load', scheduleRefresh);
    document.fonts?.ready.then(scheduleRefresh);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(scheduleRefresh);
      observer.observe(about);
    }

    refresh();
  }

  // Wait until SplitText has built paused timelines, then measure + play.
  // autoSplit is off here: a rebuild on the intro block (parked on the clip
  // edge) was resetting a paused timeline and leaving the first paragraph hidden.
  let waiting = blocks.length;

  function onBlockReady() {
    waiting -= 1;
    if (waiting <= 0) start();
  }

  blocks.forEach((block) => {
    const split = window.animateBodyText?.(block, {
      useScrollTrigger: false,
      autoPlay: false,
      autoSplit: false,
      onReady: onBlockReady,
    });

    if (!split) onBlockReady();
  });

  if (waiting <= 0) start();
});
